// Footer social buttons. Admins can change the links, which ones show and their
// order from Admin → HomePage → Social Links; this is the built-in fallback.
export const SOCIAL_LINKS_DEFAULTS = {
  twitter: "https://twitter.com",
  facebook: "https://facebook.com",
  instagram: "https://www.instagram.com/acchoosclothing?igsh=dHd2NWluOHpzaWM4",
  youtube: "https://youtube.com",
  linkedin: "",
  pinterest: "",
  show: ["twitter", "facebook", "instagram", "youtube"], // visible networks, in order
};
